import { createApiHooks, schemaToQueryParameters } from '@apis/next/common';
import { CurrencyRate, ExchangeCalendarQuery, PostCurrencyRate } from '@models/next/CurrencyRate';

export const exchangeCalendarApis = createApiHooks('/exchange-calendar', [
  {
    method: 'get',
    path: '/',
    parameters: schemaToQueryParameters(ExchangeCalendarQuery),
    response: CurrencyRate.array(),
  },
  {
    method: 'post',
    path: '/',
    parameters: [
      {
        name: 'body',
        type: 'Body',
        schema: PostCurrencyRate,
      },
    ],
    response: CurrencyRate,
  },
]);
